import { map } from "lodash";
import React from "react";
import { BsArrowUp, BsArrowDown } from "react-icons/bs";
import moment from "moment-timezone";

import { mask } from "../../../utils/mask";
import Menu from "../Menu";
import { PortalDiv } from "../Portal";

import {
  Column,
  ColumnContentWrapper,
  DoubleRow,
  FlexWrapper,
  Header,
  HeaderRow,
  OrderIconWrapper,
  PropostaPedidoWrapper,
  Row,
  Status,
  Table,
  TBody,
  THead,
} from "./styles";

const statusColors = {
  Roxo: { background: "#A357AB", color: "#A357AB" },
  Amarelo: { background: "#FFFFC0", color: "#000000" },
  Azul: { background: "#4080C0", color: "#4080C0" },
  AmareloEscuro: { background: "#B3B51B", color: "#B3B51B" },
  Vermelho: { background: "#DF1B49", color: "#DF1B49" },
  Verde: { background: "#49A11D", color: "#49A11D" },
  VerdeEscuro: { background: "#224B0D", color: "#224B0D" },
  Cinza: { background: "#9D9D9D", color: "#9D9D9D" },
};

const ListCreditTable = (props) => {
  const formatValorMonetario = (valor) => {
    return Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(valor || 0);
  };

  const HeaderColumn = (headerProps) => {
    const { orderBy, sortDirection, setOrderBy, setSortDirection } = props;
    const { children, id, sortable = true, minWidth, maxWidth } = headerProps;

    if (!sortable) {
      return (
        <Header minWidth={minWidth} maxWidth={maxWidth}>
          <FlexWrapper justify="space-between">{children}</FlexWrapper>
        </Header>
      );
    }

    const arrow =
      id === orderBy ? (
        sortDirection === "DESC" ? (
          <BsArrowDown />
        ) : (
          <BsArrowUp />
        )
      ) : null;

    const handleClick = () => {
      if (id == orderBy) {
        setSortDirection(sortDirection === "DESC" ? "ASC" : "DESC");
      } else {
        setOrderBy(id);
        setSortDirection("ASC");
      }
    };

    return (
      <Header
        minWidth={minWidth}
        maxWidth={maxWidth}
        clickable={sortable}
        onClick={handleClick}
      >
        <FlexWrapper justify="space-between">
          {children}
          <OrderIconWrapper>{arrow}</OrderIconWrapper>
        </FlexWrapper>
      </Header>
    );
  };

  const renderHeader = () => {
    return (
      <THead>
        <HeaderRow>
          <HeaderColumn id="numeroProposta" minWidth="110px">
            Proposta / Pedido
          </HeaderColumn>
          <HeaderColumn sortable={false} id="numeroCpfCnpj" minWidth="130px">
            Nome / CPF
          </HeaderColumn>
          <HeaderColumn id="dataAtualizacao">Data</HeaderColumn>
          <HeaderColumn id="nomeConvenio" minWidth="150px">
            Convênio / Loja
          </HeaderColumn>
          <HeaderColumn id="descricaoProduto" minWidth="80px">
            Produto
          </HeaderColumn>
          <HeaderColumn id="valorLiberado">Valor</HeaderColumn>
          <HeaderColumn id="codigoStatusTerceiro">
            Situação / Status
          </HeaderColumn>
          <HeaderColumn id="numeroAnalista">Analista</HeaderColumn>
          <HeaderColumn> </HeaderColumn>
        </HeaderRow>
      </THead>
    );
  };

  const renderBody = () => {
    const { propostas, updateTable } = props;

    return (
      <TBody>
        {map(propostas, (it) => {
          return (
            <Row key={it.numeroProposta}>
              <Column>
                <ColumnContentWrapper>
                  <PropostaPedidoWrapper>
                    <Status color={statusColors[it.situacaoCor].background} />
                    <DoubleRow>
                      <FlexWrapper textAlign="center">
                        {it.numeroProposta}
                      </FlexWrapper>
                      {it.numeroPedido && (
                        <FlexWrapper textAlign="center">
                          {it.numeroPedido}
                        </FlexWrapper>
                      )}
                    </DoubleRow>
                  </PropostaPedidoWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {it.nomeCliente}
                  </FlexWrapper>
                  <FlexWrapper justify="flex-start">
                    {mask(
                      it.numeroCpfCnpj,
                      it.numeroCpfCnpj.length > 11
                        ? "##.###.###/####-##"
                        : "###.###.###-##",
                      true
                    )}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <DoubleRow>
                    <FlexWrapper>
                      {moment
                        .tz(it.dataAtualizacao, "UTC")
                        .format("DD/MM/YYYY")}
                    </FlexWrapper>
                    <FlexWrapper>
                      {moment.tz(it.dataAtualizacao, "UTC").format("HH:mm")}
                    </FlexWrapper>
                  </DoubleRow>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <DoubleRow>
                    <FlexWrapper justify="flex-start">
                      {it.nomeConvenio}
                    </FlexWrapper>
                    <FlexWrapper justify="flex-start">
                      {it.nomeLoja}
                    </FlexWrapper>
                  </DoubleRow>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {it.descricaoProduto}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  {formatValorMonetario(it.valorLiberado)}
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper
                    justify="flex-start"
                    color={statusColors[it.situacaoCor].color}
                    fontWeight="bold"
                  >
                    {it.situacao?.id}&nbsp;-&nbsp;{it.situacao?.descricao}
                  </FlexWrapper>
                  <FlexWrapper justify="flex-start">
                    {it.descricaoStatus}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <DoubleRow>
                    <FlexWrapper justify="flex-start">
                      {it.nomeAnalista}
                    </FlexWrapper>
                  </DoubleRow>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <Menu
                    numeroProposta={it.numeroProposta}
                    cpfCnpj={it.numeroCpfCnpj}
                    nomeCliente={it.nomeCliente}
                    descricaoStatus={it.descricaoStatus}
                    updateTable={updateTable}
                  />
                </ColumnContentWrapper>
              </Column>
            </Row>
          );
        })}
      </TBody>
    );
  };

  return (
    <>
      <Table>
        {renderHeader()}
        {renderBody()}
      </Table>
      <PortalDiv />
    </>
  );
};

export default ListCreditTable;
